import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand",
  "use": "expand-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"expand\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"rotate(-90 12 12)\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#FFF\" /><path fill=\"#246EB9\" d=\"m10.1 19-1.5-1.5 5.8-5.5-5.8-5.5L10.1 5l7.3 7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol